/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Decline_Reason_Not_AllowedInputs */

const en_api_error_task_decline_reason_not_allowed = /** @type {(inputs: Api_Error_Task_Decline_Reason_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A decline reason is only accepted when declining the initial liability analysis.`)
};

const pt_br2_api_error_task_decline_reason_not_allowed = /** @type {(inputs: Api_Error_Task_Decline_Reason_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O motivo só é aceito ao declinar a análise inicial de culpabilidade.`)
};

/**
* | output |
* | --- |
* | "A decline reason is only accepted when declining the initial liability analysis." |
*
* @param {Api_Error_Task_Decline_Reason_Not_AllowedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_decline_reason_not_allowed = /** @type {((inputs?: Api_Error_Task_Decline_Reason_Not_AllowedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Decline_Reason_Not_AllowedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_decline_reason_not_allowed(inputs)
	return pt_br2_api_error_task_decline_reason_not_allowed(inputs)
});